import { createBrowserRouter } from "react-router-dom";
import { paths } from "./paths";

export const router = createBrowserRouter(paths);
